// src/services/container.ts
import { createContainer, asClass, InjectionMode } from "awilix"
import { AppFranchiseService } from "./services/api/franchise"
import { AppHttpService } from "./services/http"
import { AppLogger } from "./services/logger"
import { AppSessionService } from "../infrastructure/services/session"
import { AppSupportUserService } from "./services/api/supportUser"
import { AppOrderService } from "./services/api/orderManagement"
import { AppFranchiseUserService } from "./services/api/franchiseUsers"
import { AppRefundService } from "./services/api/refundAmount"

// Create Awilix container
export const loadContainer = () => {
  const Container = createContainer({
    injectionMode: InjectionMode.PROXY,
  })

  Container.register({
    logger: asClass(AppLogger).scoped(),
    sessionService: asClass(AppSessionService).singleton(),
    httpService: asClass(AppHttpService).scoped(),
    franchiseService: asClass(AppFranchiseService).scoped(),
    supportUserService: asClass(AppSupportUserService).scoped(),
    orderService: asClass(AppOrderService).scoped(),
    franchiseUserService: asClass(AppFranchiseUserService).scoped(),
    refundService: asClass(AppRefundService).singleton()
  })

  return Container
}

export const container = loadContainer()